<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="60" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.HEIGHT, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.HEIGHT, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">피지컬</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">회원님의 키를 입력하세요</div>
                    <div style="position: relative; margin-top: 40px;">
                        <input v-model="height" class="height" placeholder="숫자만 입력하세요" type="tel">
                        <div style="position: absolute; top: 50%; transform: translateY(-50%); right: 12px; font-size: 14px; font-weight: 700;">CM</div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="height !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingHeight',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            height: '',
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        async save() {
            if (this.height === '') {
                this.$GlobalStore.showAlert('키를 입력해주세요.');
                return;
            }
            const regex = /^[1-9][0-9]*$/
            if (!regex.test(this.height)) {
                this.$GlobalStore.showAlert('숫자만 입력 가능합니다.');
                return
            }
            if (this.height >= 300) {
                this.$GlobalStore.showAlert('키는 300cm까지만 입력이 가능합니다.');
                return
            }

            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('height', this.height)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.height = ''
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.setLoginInfo(res.data.loginInfo)
                this.closeCompleteAction(PROFILE_BOX_LIST.HEIGHT, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.height = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

.height {
    width: 100%;
    height: 56px;
    border-radius: 12px;
    border: none;
    padding-left: 12px;
    font-weight: 500;
    outline: none;
    background-color: #f5f5f5;
    padding-right: 40px;
}

.height::placeholder {
    font-size: 14px;
    color: #bbbbbb;
}
</style>